
import { BaseService, SanitizedResponse } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";

export interface IPlatform {
    name: string;
    slug: string;
    colors: string;
    logo_url: string;
    external_id: string;
    platform_id: string;
}

export class PlatformService extends BaseService {

    protected static instance: PlatformService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!PlatformService.instance) PlatformService.instance = new PlatformService();
        return PlatformService.instance;
    }

    getPlatforms(): Promise<SanitizedResponse<IPlatform>> {
        return this.report(this.transport.get(`/hera/api/v1/support/platform/public`, { cache: true }));
    }

    getPlatform(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/platform/slug-pid/${id}`));
    }

}
